import * as Yup from "yup";
import { INDIAN_MOBILE_REGEX, sanitizeDigits } from "./regex";

export const sanitizeMobileInput = (value) => sanitizeDigits(value, 10);

export const isValidIndianMobile = (value) => {
  const normalized = sanitizeMobileInput(value);
  if (!normalized) return false;
  return INDIAN_MOBILE_REGEX.test(normalized);
};

/**
 * Shared Yup schema for Indian mobile numbers.
 * Pass `requiredMessage` / `invalidMessage` to override defaults from i18n.
 */
export const indianMobileSchema = (t, options = {}) => {
  const {
    required = true,
    requiredMessage,
    invalidMessage,
  } = options;

  const reqMsg = requiredMessage ?? t("common.validation.mobileRequired");
  const invMsg =
    invalidMessage ?? t("common.validation.mobileInvalidIndian");

  let schema = Yup.string().transform((value, originalValue) => {
    if (originalValue === "" || originalValue == null) return "";
    return sanitizeMobileInput(originalValue);
  });

  if (required) {
    schema = schema.required(reqMsg);
  } else {
    schema = schema.nullable();
  }

  return schema.test("indian-mobile", invMsg, (value) => {
    if (!value || value === "") return !required;
    return INDIAN_MOBILE_REGEX.test(String(value));
  });
};

/** Optional mobile: empty allowed; if present must be valid Indian mobile. */
export const indianMobileSchemaOptional = (t, options = {}) => {
  const invMsg =
    options.invalidMessage ?? t("common.validation.mobileInvalidIndian");

  return Yup.string()
    .transform((value, originalValue) => {
      if (originalValue === "" || originalValue == null) return "";
      return sanitizeMobileInput(originalValue);
    })
    .test("indian-mobile-optional", invMsg, (value) => {
      if (!value || value === "") return true;
      return INDIAN_MOBILE_REGEX.test(String(value));
    });
};
